import styled from 'styled-components';

import { useColorModeContext } from '../../contexts/ColorModeContext';

// Mobile-first sizing — generous touch targets first, scale smaller on desktop.
const TRACK_WIDTH_REM = 5.2;
const TRACK_HEIGHT_REM = 3.0;
const THUMB_SIZE_REM = 2.4;
const TRACK_PADDING_REM = 0.3;
const THUMB_TRAVEL_REM =
  TRACK_WIDTH_REM - THUMB_SIZE_REM - TRACK_PADDING_REM * 2;

const Track = styled.button<{ $on: boolean }>`
  position: relative;
  width: ${TRACK_WIDTH_REM}rem;
  height: ${TRACK_HEIGHT_REM}rem;
  border-radius: 999rem;
  border: none;
  cursor: pointer;
  padding: 0;
  flex-shrink: 0;
  background-color: ${({ $on, theme }) =>
    $on ? theme.colors.accent : theme.colors.borderStrong};
  transition: background-color 0.2s ease;
  font-family: inherit;

  /* Tighten slightly on tablet+ where everything else gets denser */
  @media (min-width: 769px) {
    width: 4.6rem;
    height: 2.6rem;
  }
`;

const Thumb = styled.span<{ $on: boolean }>`
  position: absolute;
  top: ${TRACK_PADDING_REM}rem;
  left: ${TRACK_PADDING_REM}rem;
  width: ${THUMB_SIZE_REM}rem;
  height: ${THUMB_SIZE_REM}rem;
  border-radius: 50%;
  background-color: #ffffff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.2rem;
  line-height: 1;
  transform: ${({ $on }) =>
    $on ? `translateX(${THUMB_TRAVEL_REM}rem)` : 'translateX(0)'};
  transition: transform 0.2s ease;
  box-shadow: 0 0.2rem 0.4rem rgba(0, 0, 0, 0.2);

  @media (min-width: 769px) {
    width: 2rem;
    height: 2rem;
    transform: ${({ $on }) => ($on ? 'translateX(2rem)' : 'translateX(0)')};
  }
`;

export const ColorModeToggle = () => {
  const { mode, toggle } = useColorModeContext();
  const isDark = mode === 'dark';
  return (
    <Track
      type="button"
      onClick={toggle}
      role="switch"
      aria-checked={isDark}
      aria-label={isDark ? 'Switch to light mode' : 'Switch to dark mode'}
      title={isDark ? 'Switch to light mode' : 'Switch to dark mode'}
      $on={isDark}
    >
      <Thumb $on={isDark}>{isDark ? '🌙' : '☀️'}</Thumb>
    </Track>
  );
};
